//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
import { deepClone, insertCustomCssToHead, insertGlobalFunctionsToHtml } from '@/utils/util';
export default {
  name: 'form-setting',
  mixins: [i18n],
  components: {},
  props: {
    designer: Object,
    formConfig: Object
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      designerConfig: this.getDesignerConfig(),
      formActiveCollapseNames: ['1', '2'],
      formSizes: [{
        label: 'default',
        value: ''
      }, {
        label: 'large',
        value: 'large'
      }, {
        label: 'medium',
        value: 'medium'
      }, {
        label: 'small',
        value: 'small'
      }, {
        label: 'mini',
        value: 'mini'
      }],
      showEditFormCssDialogFlag: false,
      formCssCode: '',
      cssClassList: [],
      functionsCode: '',
      showFormEventDialogFlag: false,
      formEventHandlerCode: '',
      curEventName: '',
      eventParamsMap: {
        onFormCreated: 'onFormCreated() {',
        onFormMounted: 'onFormMounted() {',
        onFormDataChange: 'onFormDataChange(fieldName, newValue, oldValue, formModel, subFormName, subFormRowIndex) {'
        //'onFormValidate':     'onFormValidate() {',
      }
    };
  },
  created: function created() {
    var _this = this;
    //导入表单JSON后需要重新加载自定义CSS样式！！！
    this.designer.handleEvent('form-json-imported', function () {
      _this.formCssCode = _this.formConfig.cssCode;
      insertCustomCssToHead(_this.formCssCode);
      _this.extractCssClass();
      _this.designer.emitEvent('form-css-updated', deepClone(_this.cssClassList));
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    /* SettingPanel和FormWidget为兄弟组件, 在FormWidget加载formConfig时，
         此处SettingPanel可能无法获取到formConfig.cssCode, 故加个延时函数！ */
    setTimeout(function () {
      _this2.formCssCode = _this2.formConfig.cssCode;
      insertCustomCssToHead(_this2.formCssCode);
      _this2.extractCssClass();
      _this2.designer.emitEvent('form-css-updated', deepClone(_this2.cssClassList));
    }, 1200);
  },
  methods: {
    extractCssClass: function extractCssClass() {
      var regExp = /\..*{/g;
      var result = this.formCssCode.match(regExp);
      var cssNameArray = [];
      if (!!result && result.length > 0) {
        result.forEach(function (rItem) {
          var classArray = rItem.split(','); //切分逗号分割的多个class
          if (classArray.length > 0) {
            classArray.forEach(function (cItem) {
              var caItem = cItem.trim();
              if (caItem.indexOf('.', 1) !== -1) {
                //查找第二个.位置
                var newClass = caItem.substring(caItem.indexOf('.') + 1, caItem.indexOf('.', 1)); //仅截取第一、二个.号之间的class
                if (!!newClass) {
                  cssNameArray.push(newClass.trim());
                }
              } else if (caItem.indexOf(' ') !== -1) {
                //查找第一个空格位置
                var _newClass = caItem.substring(caItem.indexOf('.') + 1, caItem.indexOf(' ')); //仅截取第一、二个.号之间的class
                if (!!_newClass) {
                  cssNameArray.push(_newClass.trim());
                }
              } else {
                if (caItem.indexOf('{') !== -1) {
                  //查找第一个{位置
                  var _newClass2 = caItem.substring(caItem.indexOf('.') + 1, caItem.indexOf('{'));
                  cssNameArray.push(_newClass2.trim());
                } else {
                  var _newClass3 = caItem.substring(caItem.indexOf('.') + 1);
                  cssNameArray.push(_newClass3.trim());
                }
              }
            });
          }
        });
      }

      //this.cssClassList.length = 0
      this.cssClassList.splice(0, this.cssClassList.length); //清除数组必须用splice，length=0不会响应式更新！！
      this.cssClassList = Array.from(new Set(cssNameArray)); //数组去重
    },
    saveFormCss: function saveFormCss() {
      this.extractCssClass();
      this.designer.formConfig.cssCode = this.formCssCode;
      insertCustomCssToHead(this.formCssCode);
      this.showEditFormCssDialogFlag = false;
      this.designer.emitEvent('form-css-updated', deepClone(this.cssClassList));
    },
    saveGlobalFunctions: function saveGlobalFunctions() {
      var codeHints = this.$refs.gfEditor.getEditorAnnotations();
      var syntaxErrorFlag = false;
      if (!!codeHints && codeHints.length > 0) {
        codeHints.forEach(function (chItem) {
          if (chItem.type === 'error') {
            syntaxErrorFlag = true;
          }
        });
        if (syntaxErrorFlag) {
          this.$message.error(this.i18nt('designer.setting.syntaxCheckWarning'));
          return;
        }
      }
      this.designer.formConfig.functions = this.functionsCode;
      insertGlobalFunctionsToHtml(this.functionsCode);
      this.showEditFunctionsDialogFlag = false;
    },
    editFormEventHandler: function editFormEventHandler(eventName) {
      this.curEventName = eventName;
      this.formEventHandlerCode = this.formConfig[eventName];
      this.showFormEventDialogFlag = true;
    },
    saveFormEventHandler: function saveFormEventHandler() {
      var codeHints = this.$refs.ecEditor.getEditorAnnotations();
      var syntaxErrorFlag = false;
      if (!!codeHints && codeHints.length > 0) {
        codeHints.forEach(function (chItem) {
          if (chItem.type === 'error') {
            syntaxErrorFlag = true;
          }
        });
        if (syntaxErrorFlag) {
          this.$message.error(this.i18nt('designer.setting.syntaxCheckWarning'));
          return;
        }
      }
      this.formConfig[this.curEventName] = this.formEventHandlerCode;
      this.showFormEventDialogFlag = false;
    }
  }
};